<template>
  <slot name="nosticky" />
  <slot name="sticky" v-bind="{ showSticky }" />
</template>

<script>
export default {
  data() {
    return {
      nostickyFilters: null,
      stickyFilters: null,
      header: null,
      showSticky: false,
      headerHeadRoomSticky: false
    }
  },

  methods: {
    scrollWatcher() {
      let rect = this.nostickyFilters.getBoundingClientRect()
      let stickyDiff =
        getComputedStyle(this.headerHeadRoomSticky).getPropertyValue('--stickyFiltersDiff') * -1

      if (rect.bottom - this.header.offsetHeight > 0) {
        this.showSticky = false
        this.stickyFilters.style.setProperty('--top', `${stickyDiff}px`)
      } else {
        this.showSticky = true
        this.stickyFilters.style.setProperty('--top', `${stickyDiff}px`)
      }
    }
  },
  mounted() {
    //    const nostickySlot = this.$slots.nosticky && this.$slots.nosticky()

    this.nostickyFilters = document.getElementById('nostickyFilters')
    this.stickyFilters = document.getElementById('stickyFilters')
    this.header = document.querySelector('header.Header')
    this.headerHeadRoomSticky = document.querySelector('.HeaderHeadRoomSticky')

    window.addEventListener('scroll', this.scrollWatcher)
  },
  unmounted() {
    window.removeEventListener('scroll', this.scrollWatcher)
  }
}
</script>

<style lang="scss" scoped></style>
